import { useContext, useSyncExternalStore } from 'react';
import { State } from '../state';
import { ReduxContext } from './redux-context';
import type { AppStore } from './redux-types';

export const useReduxState = <TSelected>(selector: (state: State) => TSelected): TSelected => {
    const store = useContext(ReduxContext) as AppStore;
    return useSyncExternalStore(
        store.subscribe,
        () => selector(store.getState()),
        () => selector(store.getState())
    );
};

export const useReduxDispatch = () => {
    const store = useContext(ReduxContext) as AppStore;
    return store.dispatch;
};
